import { render } from "./DesignerBar.vue?vue&type=template&id=539be5e0&scoped=true"
import script from "./DesignerBar.vue?vue&type=script&lang=js"
export * from "./DesignerBar.vue?vue&type=script&lang=js"

import "./DesignerBar.vue?vue&type=style&index=0&id=539be5e0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539be5e0"]])

export default __exports__